<template>
  <div class="home">
    <div v-if="viewport.gt.sm" class="section-numbers">
      <div v-for="(section, sectionIndex) in sections"
           :key="`section-${sectionIndex}`"
           class="section-number"
           :class="activeSectionLink === section.id ? 'active' : ''"
           @click="handleSectionNumberClick(section.id)">
        0{{sectionIndex + 1}}
      </div>
    </div>
    <Section id="header">
      <Header/>
    </Section>
    <Section id="services">
      <Services/>
    </Section>
    <Section id="products">
      <Products/>
    </Section>
    <Section id="meet-us">
      <MeetUs/>
    </Section>
    <div class="bg-sign"></div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

import Header from '@/components/home/Header.vue';
import Services from '@/components/home/Services.vue';
import Products from '@/components/home/Products.vue';
import MeetUs from '@/components/home/MeetUs.vue';
import Section from '@/components/Section.vue';

export default {
  name: 'home',
  components: {
    Header,
    Services,
    Products,
    MeetUs,
    Section,
  },
  data() {
    return {
      sections: [
        {
          id: 'header',
        },
        {
          id: 'services',
        },
        {
          id: 'products',
        },
        {
          id: 'meet-us',
        },
      ],
    };
  },
  computed: {
    ...mapState('sections', ['activeSectionLink']),
    ...mapState('viewport', ['viewport']),
  },
  created() {
    this.$options.VueScrollToOptions = {
      container: document.scrollingElement,
      easing: 'ease-in',
      offset: -184,
      force: true,
      cancelable: false,
      onStart: () => {
        // scrolling started
        this.setScrollingState(true);
      },
      onDone: () => {
        // scrolling is done
        this.setScrollingState(false);
      },
      onCancel() {
        // scrolling has been interrupted
      },
      x: false,
      y: true,
    };
  },
  methods: {
    ...mapActions('sections', ['scrollToSection']),
    ...mapMutations('sections', ['setScrollingState', 'setActiveSectionLink']),
    handleSectionNumberClick(section) {
      const {
        $options: { VueScrollToOptions: options },
        scrollToSection,
        setActiveSectionLink,
      } = this;
      setActiveSectionLink(section);
      scrollToSection({ section, options });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../styles/variables';
.home{
  position: relative;
  min-height: 100vh;
  padding-top: 135px;
  .section-numbers{
    position: fixed;
    top: 313px;
    left: 80px;
    z-index: 880;
  }
  .section-number{
    margin-bottom: 60px;
    font-size: 14px;
    font-weight: 300;
    color: #D8D8D8;
    transition: color 0.3s;
    cursor: pointer;
    &:last-child{
      margin-bottom: 0;
    }

    &.active{
      color: #40B8FF;
      font-weight: 600;
    }
  }
}

.bg-sign{
  width: 547px;
  height:  608px;
  position: fixed;
  background-image:  url('../assets/about_bg_sign.png');
  background-size: cover;
  background-position: center;
  top: 80px;
  left: 70px;
  z-index: 600;
  animation: rotate 65s linear infinite;
}

@keyframes rotate {
  0%{
    transform: rotateZ(0);
  }
  100%{
    transform: rotateZ(1turn);
  }
}

@media (min-width: $breakpoint-sm-min) {
  .home{
    padding-top: 215px;
  }
  .bg-sign{
    width: 1107px;
    height: 1230px;
    left: 0;
    top: -400px;
  }
}

@media (min-width: $breakpoint-md-min) {
  .bg-sign{
    width: 819px;
    height: 910px;
    right: -80px;
    top: -20px;
    left: auto;
  }
}

@media (min-width: $breakpoint-lg-min) {
  .home{
    padding-top: 240px;
    .section-numbers{
      top: 355px;
    }
  }
  .bg-sign{
    width: 1107px;
    height: 1230px;
    top: -332px;
    right: -78px;
  }
}
</style>
